import { useTranslation } from 'react-i18next'
import { parseISO } from 'date-fns'

import { CalendarEvent } from 'js/lib/helpers/eventCalendarLink/CalendarEvent'
import google from 'js/lib/helpers/eventCalendarLink/service/google'
import ics from 'js/lib/helpers/eventCalendarLink/service/ics'
import office365 from 'js/lib/helpers/eventCalendarLink/service/office365'
import outlook from 'js/lib/helpers/eventCalendarLink/service/outlook'
import isMobile from 'js/lib/helpers/isMobile'
import sortByProperty from 'js/lib/helpers/sortByProperty'

import { AddToCalendarProps } from './AddToCalendar'

export default function useAddToCalendar({
    entity,
    site,
    window,
    navigator,
}: AddToCalendarProps & {
    window: Window
    navigator: Navigator
}) {
    const { t } = useTranslation()

    const event = {
        start: parseISO(entity.startDate),
        end: entity.endDate ? parseISO(entity.endDate) : null,
        title: entity.title,
        excerpt: entity.excerpt,
        location: entity.location,
        locationAddress: entity.locationAddress,
        locationLink: entity.locationLink,
        videoCallUrl: site.integratedVideocallEnabled
            ? entity.videoCallUrl
            : undefined,
        eventPageUrl: window.location.href,
    } satisfies CalendarEvent

    const isMobileNavigator = isMobile(navigator)
    const createAppleOption = ics('Apple')
    const createGoogleOption = google('Google')
    const createAgendaOption = ics(
        t('entity-event.agenda'),
        t('entity-event.download-calendar-item'),
    )
    const createOutlookOption = outlook('Outlook', isMobileNavigator)
    const createOffice365Option = office365('Office 365', isMobileNavigator)

    const sortedOptions = [
        createAppleOption(event),
        createGoogleOption(event),
        createAgendaOption(event),
        createOutlookOption(event),
        createOffice365Option(event),
    ].sort(sortByProperty('label'))

    return {
        options: sortedOptions,
    }
}
